
import themeMixin from '~/mixins/theme'

export default {
  name: 'Select',
  mixins: [themeMixin],
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    displayName: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
    showClear: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      randomId: null,
      focused: false,
      hovered: false,
    }
  },
  computed: {
    listeners() {
      const { input, ...rest } = this.$listeners

      return rest
    },
    empty() {
      return !this.value
    },
    themeContrast() {
      return this.getIconContrastColor(this.theme)
    },
  },
  mounted() {
    // Generate a random id to associate the form to the label
    this.randomId = (Math.random() + 1).toString(36).substring(7)
  },
  methods: {
    focusHandler() {
      this.focused = true
    },
    blurHandler() {
      this.focused = false
      this.$refs.fakeInput.dispatchEvent(new Event('blur'))
    },
  },
}
